/**
 * A service category whose VQQ template only one client uses (Airtable "Client Access": Local)
 * can appear on that client's vendor profiles and in Vendor Discovery, but the Document, RFI and
 * Audit Report Library filters do not offer it. Categories the catalog sync has not classified
 * yet carry no client_access and stay.
 */
export const isLocalTemplateCategory = (rfi) =>
  String(rfi?.client_access ?? "").trim().toLowerCase() === "local";

export const withoutLocalTemplateCategories = (rfis) =>
  Array.isArray(rfis) ? rfis.filter((rfi) => !isLocalTemplateCategory(rfi)) : rfis;
